import React from 'react'
import { getValuationMethodLabel } from '../helpers/valuationMethods'
import { getConfidencePresentation, getSameConditionCount } from '../helpers/valuationEvidence'

const formatCount = (value) => (Number.isFinite(Number(value)) ? Number(value).toLocaleString('cs-CZ') : '—')

const ValuationEvidenceSummary = ({ value, method, conditionTargets = [] }) => {
  const confidence = getConfidencePresentation(value?.confidence)
  const usedCount = Number(value?.compsUsed) || 0
  const availableCount = Number(value?.availableComparables) || 0
  const sameConditionCount = getSameConditionCount(value, conditionTargets)
  const radius = Math.round(Number(value?.usedSearchRadiusMeters ?? value?.searchRadiusMeters) || 0)

  return (
    <div className="mt-4 rounded-xl border border-slate-200 bg-white/75 p-3 text-slate-800">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <div className="text-xs font-semibold text-slate-900">Podloženo nabídkami z okolí</div>
          <p className="mt-1 text-[11px] leading-4 text-slate-600">
            Model vybral {formatCount(usedCount)} nejrelevantnějších z {formatCount(availableCount)} vhodných nabídek.
          </p>
        </div>
        <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${confidence.badgeClassName}`}>
          {confidence.label}{confidence.percent === null ? '' : ` · ${confidence.percent} %`}
        </span>
      </div>

      {confidence.percent !== null && (
        <div
          className="mt-3 h-1.5 overflow-hidden rounded-full bg-slate-200"
          role="progressbar"
          aria-label="Důvěra odhadu"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow={confidence.percent}
        >
          <div className={`h-full rounded-full ${confidence.barClassName}`} style={{ width: `${confidence.percent}%` }} />
        </div>
      )}

      <div className="mt-3 grid grid-cols-2 gap-2 text-[11px] sm:grid-cols-3">
        <div className="col-span-2 rounded-lg bg-slate-50 px-2.5 py-2 sm:col-span-1">
          <span className="block font-semibold text-slate-900">{formatCount(usedCount)}</span>
          <span className="text-slate-500">použitých srovnání</span>
        </div>
        <div className="rounded-lg bg-slate-50 px-2.5 py-2">
          <span className="block font-semibold text-slate-900">{formatCount(sameConditionCount)}</span>
          <span className="text-slate-500">se shodným stavem</span>
        </div>
        <div className="rounded-lg bg-slate-50 px-2.5 py-2">
          <span className="block font-semibold text-slate-900">{formatCount(radius)} m</span>
          <span className="text-slate-500">analyzované okolí</span>
        </div>
      </div>

      <details className="mt-3 border-t border-slate-200 pt-2">
        <summary className="cursor-pointer select-none text-[11px] font-medium text-slate-600 hover:text-slate-900">
          Jak odhad vznikl?
        </summary>
        <p className="mt-2 text-[11px] leading-4 text-slate-600">
          {getValuationMethodLabel(method, value?.methodLabel)}. Nabídky se porovnávají podle podobnosti a jejich cenu model upravuje na parametry oceňované nemovitosti.
        </p>
      </details>
    </div>
  )
}

export default ValuationEvidenceSummary
